import { useMsal } from '@azure/msal-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTable } from 'react-table';
import { TableSkelton } from '../../Components/Common/skelton';
import { SelectSearchValInStore } from '../../Store/commonStore/selectors';
import { needSchema } from '../../common/data/TableSchema';
import { typeOfNeeds } from './utils';
// import UntagConfirmModal from './UntagConfirmModal';

function useInstance(instance) {
    const { allColumns } = instance;

    let rowSpanHeaders = [];

    allColumns.forEach((column, i) => {
        const { id, enableRowSpan } = column;

        if (enableRowSpan !== undefined) {
            rowSpanHeaders = [...rowSpanHeaders, { id, topCellValue: null, topCellIndex: 0 }];
        }
    });

    Object.assign(instance, { rowSpanHeaders });
}

const NeedGridCompoent = ({
    handleAddGoalOrActionItem,
    tableViewData,
    handleGapsEdit,
    isOffline,
    handleEditGoal,
    loading,
    assessmentData,
    allData,
    callGoals,
    rowStatus
}) => {
    const [data, setData] = React.useState([]);
    const [showUntagModal, setShowUntagModal] = React.useState(false);
    const [unTagNeedIdList, setUnTagNeedIdList] = React.useState([]);

    const roleVal = useSelector((state) => SelectSearchValInStore(state, 'roleVal'));
    const { accounts } = useMsal();
    const roleID = roleVal?.roleID;
    const columns = React.useMemo(() => needSchema, []);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, rowSpanHeaders } = useTable({ columns, data }, (hooks) => {
        hooks.useInstance.push(useInstance);
    });

    // Make a function
    const onActionClick = (gapId, actionType, rowData) => {
        handleGapsEdit(gapId, actionType, rowData?.original);
    };
    React.useEffect(() => {
        setData(tableViewData);
    }, [tableViewData]);

    const prepareCustomBody = (cell, row, index) => {
        let body = undefined;
        switch (cell?.column?.fieldType) {
            case 'category':
                body = (
                    <>
                        <span className="fs-14 text-orangeColor px-2 mt-8 d-block  mb-2">{cell.render('Cell')}</span>
                    </>
                );
                break;
            case 'subCategory':
                body = (
                    <>
                        <b>
                            <span
                                className={`m-2 ${
                                    row?.original?.needType === typeOfNeeds.custom
                                        ? 'badge-soft-success'
                                        : row?.original?.needType === typeOfNeeds.auto
                                        ? 'badge-soft-secondary'
                                        : 'badge-soft-danger'
                                } px-2 fs-12 fw-medium py-1`}
                            >
                                {row.original.needType === typeOfNeeds.auto
                                    ? 'Automatic'
                                    : row.original.needType === typeOfNeeds.custom
                                    ? 'Manual'
                                    : 'Untag'}
                            </span>
                        </b>
                        <span className={'fs-14 px-2 mt-8 d-block  mb-2 text-wrap'}>{row.original.subCategory}</span>

                        {!(rowStatus === 'approved') && row?.original?.needType !== typeOfNeeds.untag && (
                            <p className="fs-14 mb-0 text-primary px-2 pb-3" title="Add Goal">
                                <button
                                    type="button"
                                    className="btn btn-soft-primary btn-sm me-2 rounded-pill sm-btn"
                                    onClick={() => handleAddGoalOrActionItem(row?.original, cell?.column?.titleName)}
                                    id="addNeeds"
                                >
                                    <i className="ri-add-fill fs-18 fw-bold"></i>
                                </button>
                                {cell?.column?.titleName}
                            </p>
                        )}
                        {/* {row?.original?.needType === typeOfNeeds.auto && (
                            <button
                                className="d-flex align-items-center border-danger bg-white rounded-2 text-danger mx-3 mb-4 border-3"
                                title="Untag"
                                onClick={() => handleAddGoalOrActionItem(row.original, 'Untag')}
                            >
                                <i class="ri-link-unlink fs-18 text-danger me-2" />
                                Untag
                            </button>
                        )} */}
                    </>
                );
                break;
            case 'actions':
                body = (
                    <div className="d-flex">
                        {cell?.column?.isEdit && row?.original?.canView && (
                            <i
                                className="ri-eye-line align-middle fs-18 cursor-pointer primary-color text-primary"
                                onClick={() => onActionClick(row.original.gapId, 'view', row)}
                                id={'view'}
                            ></i>
                        )}
                        {!(rowStatus === 'approved') && cell?.column?.isEdit && row?.original?.canEdit && (
                            <i
                                className="ri-pencil-line align-middle fs-18 cursor-pointer primary-color text-primary"
                                onClick={() => onActionClick(row.original.gapId, 'edit', row)}
                                id={'edit'}
                            ></i>
                        )}
                    </div>
                );
                break;

            default:
                break;
        }
        return body;
    };

    return loading ? (
        <TableSkelton />
    ) : (
        <div className="custom-table table-responsive">
            <table {...getTableProps()} className="table table-bordered table-centered align-middle mb-0">
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    key={column.id}
                                    className={column.thClass}
                                    width={column.width}
                                    {...(column.sortable ? column.getSortByToggleProps() : '')}
                                    {...column.getHeaderProps({})}
                                >
                                    {column.render('Header')}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row);

                        for (let j = 0; j < row.allCells.length; j++) {
                            let cell = row.allCells[j];
                            let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);

                            if (rowSpanHeader !== undefined) {
                                if (rowSpanHeader.topCellValue === null || rowSpanHeader.topCellValue !== cell.value) {
                                    cell.isRowSpanned = false;
                                    rowSpanHeader.topCellValue = cell.value;
                                    rowSpanHeader.topCellIndex = i;
                                    cell.rowSpan = 1;
                                } else {
                                    rows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                                    cell.isRowSpanned = true;
                                }
                            }
                        }
                        return null;
                    })}
                    {rows?.length ? (
                        rows.map((row, index) => {
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell, i) => {
                                        if (cell.isRowSpanned) return null;
                                        else {
                                            if (row.original.goal) {
                                                if (row.original.actionPlanName) {
                                                    return (
                                                        <td
                                                            rowSpan={cell.rowSpan}
                                                            {...cell.getCellProps()}
                                                            // title={cell.value}
                                                            title={
                                                                cell?.column?.Header === 'Action Item' ? '' : cell.value?.split('---')[0]
                                                            }
                                                            className={
                                                                cell.column?.classess + ` ${cell.column?.checkStatus && ' text-muted'}`
                                                            }
                                                        >
                                                            {cell.column.customCell
                                                                ? prepareCustomBody(cell, row, index)
                                                                : cell.render('Cell')}
                                                        </td>
                                                    );
                                                } else {
                                                    return (
                                                        i < 3 && (
                                                            <td
                                                                rowSpan={cell.rowSpan}
                                                                {...cell.getCellProps()}
                                                                title={cell.value}
                                                                className={`${cell.column?.classess} `}
                                                                colSpan={i === 2 && '3'}
                                                            >
                                                                {i < 2 ? (
                                                                    prepareCustomBody(cell, row, index)
                                                                ) : (
                                                                    <section className="w-100">
                                                                        <span
                                                                            className={`d-flex justify-content-between ${
                                                                                false && 'text-muted'
                                                                            }`}
                                                                        >
                                                                            <span className="w-40">{cell.render('Cell')}</span>

                                                                            {!(rowStatus === 'approved') &&
                                                                                row?.original?.needType !== typeOfNeeds.untag && (
                                                                                    <span>
                                                                                        <i
                                                                                            id="editGoal"
                                                                                            className="ri-pencil-fill fs-14 fw-bold text-primary me-4 cursor-pointer"
                                                                                            title="Edit Goal"
                                                                                            onClick={() =>
                                                                                                handleEditGoal(
                                                                                                    row.original.goal,
                                                                                                    row.original?.goalId
                                                                                                )
                                                                                            }
                                                                                        ></i>
                                                                                    </span>
                                                                                )}
                                                                        </span>
                                                                    </section>
                                                                )}
                                                            </td>
                                                        )
                                                    );
                                                }
                                            } else {
                                                return (
                                                    i < 2 && (
                                                        <td
                                                            rowSpan={cell.rowSpan}
                                                            {...cell.getCellProps()}
                                                            title={cell.value}
                                                            className={`${cell.column.classess} `}
                                                            colSpan={i === 1 && '3'}
                                                        >
                                                            {i === 0 ? (
                                                                prepareCustomBody(cell, row, index)
                                                            ) : (
                                                                <>
                                                                    <b>
                                                                        <span
                                                                            className={`m-2 ${
                                                                                row?.original?.needType === typeOfNeeds.custom
                                                                                    ? 'badge-soft-success'
                                                                                    : row?.original?.needType === typeOfNeeds.auto
                                                                                    ? 'badge-soft-secondary'
                                                                                    : 'badge-soft-danger'
                                                                            } px-2 fs-12 fw-medium py-1`}
                                                                        >
                                                                            {row.original.needType === typeOfNeeds.auto
                                                                                ? 'Automatic'
                                                                                : row.original.needType === typeOfNeeds.custom
                                                                                ? 'Manual'
                                                                                : 'Untag'}
                                                                        </span>
                                                                    </b>
                                                                    <span className="d-flex justify-content-between p-2">
                                                                        <span className={`${false && 'text-muted mb-3'}`}>
                                                                            {cell.render('Cell')}
                                                                        </span>

                                                                        {!(rowStatus === 'approved') &&
                                                                            row?.original?.needType === typeOfNeeds.auto && (
                                                                                <button
                                                                                    className="d-flex align-items-center border-danger bg-white rounded-2 text-danger me-3 mb-2 border-3"
                                                                                    title="Untag"
                                                                                    onClick={() =>
                                                                                        handleAddGoalOrActionItem(row.original, 'Untag')
                                                                                    }
                                                                                >
                                                                                    <i class="ri-link-unlink fs-18 text-danger me-2" />
                                                                                    Untag
                                                                                </button>
                                                                            )}
                                                                        {!(rowStatus === 'approved') &&
                                                                            row?.original?.needType !== typeOfNeeds.untag && (
                                                                                <span className="text-primary mb-3" title="Add Goal">
                                                                                    <i
                                                                                        className="ri-add-fill fs-18 fw-bold btn btn-soft-primary btn-sm me-2 rounded-pill sm-btn"
                                                                                        onClick={() =>
                                                                                            handleAddGoalOrActionItem(row?.original, 'Goal')
                                                                                        }
                                                                                    />
                                                                                    Add Goal
                                                                                </span>
                                                                            )}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </td>
                                                    )
                                                );
                                            }
                                        }
                                    })}
                                </tr>
                            );
                        })
                    ) : (
                        <div className="py-4 px-2">No Records found.</div>
                    )}
                </tbody>
            </table>
        </div>
    );
};
export default NeedGridCompoent;
